<section class="snack">
  <div class="snack__text">
    <img src="../../../assets/icons/error-white.svg">
    <p class="title">{{text}}</p>
  </div>
  <div class="snack__divider"></div>
  <div class="snack__close" (click)="close()">
    <img src="../../../assets/icons/close-white.svg">
  </div>
</section>
